import {
  FETCH_AROUND,
  FETCH_BEST_RANKS,
  FETCH_LATEST_BLOG,
  FETCH_SIMILAR,
  FETCH_STATISTICS,
  FETCH_PICTURES,
  FETCH_SELECTED_CATEGORIES,
  FETCH_BANNERS_PICTURE,
  FETCH_SHOMAL,
  FETCH_THRAN_CITY,
  FETCH_RESERVED_HOUSES,
  FETCH_JONOOB,
  FETCH_HERO,
  FETCH_BOOMGARDI,
} from '../actions/types'

interface Banner {
  id: number
  name: string
  image: string
  webp_image: string | null
  title: string
  link: string
  sort: number
  type: 2 | 3
  platform: 1 | 2
}

export interface HomeBannersProps {
  data: Banner[]
  loading: boolean
}

interface HomeBannersAction extends HomeBannersProps {
  type: string
}

export const homeBanners = (
  state: HomeBannersProps = { data: [], loading: false },
  { type, data, loading }: HomeBannersAction,
): HomeBannersProps => {
  switch (type) {
    case FETCH_BANNERS_PICTURE:
      return { data, loading }

    default:
      return state
  }
}

export type IHouseType =
  | 'apartment'
  | 'villa'
  | 'boomgardi'
  | 'cottage'
  | 'pool'
  | 'coastal'
  | 'omg'

export type IPicturesHouse = {
  id: string
  is_default: boolean
  absolute_url: string
  caption: string
  thumbnail_absolute_url: string
}
export interface HouseCardItemProps {
  id: number
  title: string
  type: IHouseType
  area_type: string
  total_beds: number
  pricing: {
    median_price: {
      amount: number
      currency_name: string
      currency_short_form: string
    }
    max_price: {
      amount: number
      currency_name: string
      currency_short_form: string
    }
    min_price: {
      amount: number
      currency_name: string
      currency_short_form: string
    }
    total: {
      amount: number
      currency_name: string
      currency_short_form: string
    }
    total_without_discount_days: {
      amount: number
      currency_name: string
      currency_short_form: string
    }
    total_without_discount: {
      amount: number
      currency_name: string
      currency_short_form: string
    }
    price_without_discount: {
      amount: number
      currency_name: string
      currency_short_form: string
    }
    price_after_discount: {
      amount: number
      currency_name: string
      currency_short_form: string
    }
    price_to_show: {
      amount: number
      currency_name: string
      currency_short_form: string
    }
    instant_price: {
      amount: number
      currency_name: string
      currency_short_form: string
    }
    today_price: {
      amount: number
      currency_name: string
      currency_short_form: string
    }
  }
  location: {
    city: string
    province: string
    latitude: string
    longitude: string
    village: string
  }
  mehman_navaz: number
  rank: number
  rooms: number
  accommodates: number
  max_accommodates: number
  extra_accommodates: number
  extra_person: number
  days_stay: number
  reviews: number
  beds: number
  badges?: string[]
  price_guarantee: number
  cover_photo: {
    id: string
    is_default: boolean
    absolute_url: string
    caption: string
    thumbnail_absolute_url: string
  }
  has_watermarked_photo: boolean
  has_long_term_discount: boolean
  with: {
    photos: IPicturesHouse[]
    features: string[]
  }
}

export interface LateNightStateProps {
  list: HouseCardItemProps[]
  loading: boolean
}

interface LateNightActionProps extends LateNightStateProps {
  type: string
}

export interface PicturesStateProps {
  list: IPicturesHouse[]
  loading: boolean
}

interface PicturesActionProps extends PicturesStateProps {
  type: string
}

export interface HeroImageType {
  mobile: null | string
  desktop: null | string
}
const heroImageInitialState: HeroImageType = { mobile: null, desktop: null }
export const heroImage = (
  state = heroImageInitialState,
  { type, payload }: { type: string; payload: HeroImageType },
) => {
  switch (type) {
    case FETCH_HERO:
      return payload
    default:
      return state
  }
}
export const aroundHouses = (
  state: LateNightStateProps = { list: [], loading: false },
  { type, list, loading }: LateNightActionProps,
): LateNightStateProps => {
  switch (type) {
    case FETCH_AROUND:
      return { list, loading }
    default:
      return state
  }
}
export const shomalHouses = (
  state: LateNightStateProps = { list: [], loading: false },
  { type, list, loading }: LateNightActionProps,
): LateNightStateProps => {
  switch (type) {
    case FETCH_SHOMAL:
      return { list, loading }
    default:
      return state
  }
}

export const jonoobHouses = (
  state: LateNightStateProps = { list: [], loading: false },
  { type, list, loading }: LateNightActionProps,
): LateNightStateProps => {
  switch (type) {
    case FETCH_JONOOB:
      return { list, loading }
    default:
      return state
  }
}
export const tehranHouses = (
  state: LateNightStateProps = { list: [], loading: false },
  { type, list, loading }: LateNightActionProps,
): LateNightStateProps => {
  switch (type) {
    case FETCH_THRAN_CITY:
      return { list, loading }
    default:
      return state
  }
}
export const boomgardiHouses = (
  state: LateNightStateProps = { list: [], loading: false },
  { type, list, loading }: LateNightActionProps,
): LateNightStateProps => {
  switch (type) {
    case FETCH_BOOMGARDI:
      return { list, loading }
    default:
      return state
  }
}
export type ReservList = {
  list: {
    expired_at: string
    status: { state: string }
    invoice: { id: string }
    house: { id: number }
  }[]
  loading: false
  type?: string
}

export const houseReserve = (
  state: ReservList = { list: [], loading: false },
  { type, list, loading }: ReservList,
): ReservList => {
  switch (type) {
    case FETCH_RESERVED_HOUSES:
      return { list, loading }
    default:
      return state
  }
}
export interface MostVisitedCityProps {
  name: string
  absolute_photo_url: string
  houses_count: number
}

// statistics:
export interface StatisticsProps {
  housesCount: number
  nightsGuests: number
  instantHousesCount: number
  ReviewsAndCommentsCount: number
  dailyVisit: number
  yearsExperience: number
}

export interface StatisticsState {
  data: StatisticsProps
  loading: boolean
}

interface StatisticsAction extends StatisticsState {
  type: string
}

export const statistics = (
  state: StatisticsState = {
    data: {
      ReviewsAndCommentsCount: 0,
      housesCount: 0,
      instantHousesCount: 0,
      nightsGuests: 0,
      dailyVisit: 0,
      yearsExperience: 0,
    },
    loading: false,
  },
  { type, data, loading }: StatisticsAction,
): StatisticsState => {
  switch (type) {
    case FETCH_STATISTICS:
      return { data, loading }

    default:
      return state
  }
}

// latest blog:
export interface LatestBlogProps {
  link: string
  title: string
  thumbnail_path: string
}

export interface LatestBlogState {
  list: LatestBlogProps[]
  loading: boolean
}

interface LatestBlogAction extends LatestBlogState {
  type: string
}

export const latestBlog = (
  state: LatestBlogState = { list: [], loading: false },
  { type, list, loading }: LatestBlogAction,
): LatestBlogState => {
  switch (type) {
    case FETCH_LATEST_BLOG:
      return { list, loading }

    default:
      return state
  }
}

// Best Ranks :
// export interface BestRanksProps {
//   id: number
//   title: string
//   city: string
//   type: string
//   ranks: number
// }

export interface BestRanksState {
  list: HouseCardItemProps[]
  loading: boolean
}

interface BestRanksAction extends BestRanksState {
  type: string
}

export const bestRanks = (
  state: BestRanksState = { list: [], loading: false },
  { type, list, loading }: BestRanksAction,
): BestRanksState => {
  switch (type) {
    case FETCH_BEST_RANKS:
      return { list, loading }

    default:
      return state
  }
}

// similar Houses
export const similarHouses = (
  state: LateNightStateProps = { list: [], loading: true },
  { type, list, loading }: LateNightActionProps,
): LateNightStateProps => {
  switch (type) {
    case FETCH_SIMILAR:
      return { list, loading }

    default:
      return state
  }
}

// pictures Houses
export const picturesHouses = (
  state: PicturesStateProps = { list: [], loading: false },
  { type, list, loading }: PicturesActionProps,
): PicturesStateProps => {
  switch (type) {
    case FETCH_PICTURES:
      return { list, loading }

    default:
      return state
  }
}

export interface SelectedCategoriesItem {
  title: string
  count: number
  image_path: string
  related_link: string
}

export interface SelectedCategoriesProps {
  list: SelectedCategoriesItem[]
  loading: boolean
}

interface SelectedCategoriesActionProps extends SelectedCategoriesProps {
  type: string
}

export const selectedCategories = (
  state: SelectedCategoriesProps = { list: [], loading: false },
  { type, list, loading }: SelectedCategoriesActionProps,
) => {
  switch (type) {
    case FETCH_SELECTED_CATEGORIES:
      return { ...state, list, loading }

    default:
      return state
  }
}
